import * as React from 'react';

type Kind = 'page' | 'form' | 'list' | 'text';

export function RouteSkeleton({ kind = 'page' }: { kind?: Kind }) {
  const block = (w: string, h: number, mt: number = 12) => (
    <div
      style={{
        width: w,
        height: h,
        marginTop: mt,
        borderRadius: 8,
        background:
          'linear-gradient(90deg, rgba(0,0,0,0.06) 25%, rgba(0,0,0,0.12) 37%, rgba(0,0,0,0.06) 63%)',
        backgroundSize: '400% 100%',
        animation: 'shimmer 1.4s ease-in-out infinite',
      }}
      aria-hidden="true"
    />
  );

  const rows = () => {
    switch (kind) {
      case 'form':
        return (
          <>
            {block('60%', 28, 0)}
            {block('100%', 44)}
            {block('40%', 28, 24)}
            {block('100%', 44)}
            {block('30%', 40, 24)}
          </>
        );
      case 'list':
        return (
          <>
            {block('30%', 28, 0)}
            {block('100%', 80)}
            {block('100%', 80)}
            {block('100%', 80)}
          </>
        );
      case 'text':
        return (
          <>
            {block('50%', 28, 0)}
            {block('100%', 16)}
            {block('90%', 16)}
            {block('95%', 16)}
            {block('80%', 16)}
          </>
        );
      default:
        return (
          <>
            {block('55%', 32, 0)}
            {block('100%', 16)}
            {block('95%', 16)}
            {block('90%', 16)}
            {block('85%', 16)}
          </>
        );
    }
  };

  return (
    <div role="status" aria-busy="true" style={{ padding: 24 }}>
      <style>{`
        @keyframes shimmer {
          0% { background-position: 100% 0; }
          100% { background-position: -100% 0; }
        }
      `}</style>
      {rows()}
    </div>
  );
}

export default RouteSkeleton;
